var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 13.334V8.75H2.917a.75.75 0 1 1 0-1.5H7.5V2.667a.75.75 0 0 1 1.5 0V7.25h4.584l.076.004a.75.75 0 0 1 0 1.492l-.076.004H9v4.584a.75.75 0 0 1-1.5 0"
  })));
};
export default Svg16;